import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class InvoiceApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/invoice' + path, queryMap);
  }

  findUserEligibleOrders(page: number, page_size: number) {
    const q = { page, page_size };
    const url = this.buildurl('/eligible-orders', q);
    return this.http.fget(url);
  }

  postInvoice(
    type: string,
    title: string,
    tax_no: string,
    email: string,
    order_ids: any,
  ) {
    const body = {
      type,
      title,
      tax_no,
      email,
      order_ids,
    };
    const url = this.buildurl('');
    return this.http.post(url, body);
  }
}
